import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { errorMessageComponent } from './error-message.component';



@NgModule({
  declarations: [errorMessageComponent],
  imports: [
	CommonModule,
    RouterModule
  ],
  exports: [errorMessageComponent]
})
export class ErrorMessageModule { }
